import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/pro-solid-svg-icons';
import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons';
import { ButtonLink } from '@design-system/components/button/button';
import { Typography } from '@design-system/components/typography/typography';
import { AllEmptyValue } from './workouts.viewModel';
import * as s from './WorkoutTypesEmptyState.css';

export const WorkoutTypesEmptyState = ({
  createWorkoutURL,
  createClassURL,
  goToWorkoutsURL,
}: AllEmptyValue) => (
  <div className={s.wrapper}>
    <Typography variant="body" size="large" color="N-90" fontWeight="normal">
      Fill out your programs with one of our workout types
    </Typography>
    <div className={s.cardsRow}>
      <div className={s.card}>
        <div className={s.textGroup}>
          <Typography variant="body" size="xsmall" color="N-80">
            NEW
          </Typography>
          <Typography
            variant="body"
            size="small"
            fontWeight="bold"
            color="P-80"
          >
            CREATE A WORKOUT OR CLASS
          </Typography>
          <Typography
            variant="body"
            size="medium"
            fontWeight="normal"
            color="B-100"
          >
            Build a new workout from scratch. Add clips, set intervals, and
            configure rounds.
          </Typography>
        </div>
        <div className={s.buttons}>
          <ButtonLink to={createWorkoutURL} className={s.tonalButton}>
            <FontAwesomeIcon icon={faPlus} />
            New workout
          </ButtonLink>
          <ButtonLink to={createClassURL} className={s.tonalButton}>
            <FontAwesomeIcon icon={faPlus} />
            New class
          </ButtonLink>
        </div>
        <div className={s.info}>
          <FontAwesomeIcon icon={faInfoCircle} />
          <Typography variant="body" size="small" color="N-60">
            Opens the workout builder
          </Typography>
        </div>
      </div>
      <div className={s.card}>
        <div className={s.textGroup}>
          <Typography variant="body" size="xsmall" color="N-80">
            EXISTING{' '}
          </Typography>
          <Typography
            variant="body"
            size="small"
            fontWeight="bold"
            color="P-80"
          >
            ASSIGN FROM EXISTING WORKOUTS
          </Typography>
          <Typography
            variant="body"
            size="medium"
            fontWeight="normal"
            color="B-100"
          >
            Pick existing workouts or classes you&apos;ve already built. Any
            edits to the original will reflect here.
          </Typography>
        </div>
        <div className={s.buttons}>
          <ButtonLink to={goToWorkoutsURL} className={s.tonalButton}>
            <FontAwesomeIcon icon={faPlus} />
            Go to Workouts
          </ButtonLink>
        </div>
        <div className={s.info}>
          <FontAwesomeIcon icon={faInfoCircle} />
          <Typography variant="body" size="small" color="N-60">
            Opens your draft workouts list
          </Typography>
        </div>
      </div>
    </div>
  </div>
);
